<template>
  <div class="event-card" @click="gotoLink">
    <!--<div class="watchlist"><i class="sl-icon-eye"></i> <span class="views">{{ ticketCount }}</span></div>-->
    <div class="thumb" :style="cardStyle">
      <div class="live">
        <i class="sl-icon-camrecorder"></i>
      </div>
    </div>
    <div class="info">
      <div class="title">
        <div class="price" v-if="live.price">
          {{ formatPrice }}
        </div>
        <div class="price free" v-else>
          {{ formatPrice }}
        </div>
        <div class="when">
          {{ when }}
        </div>
      </div>
      <div class="who" v-if="to">
        <router-link :to="to" ref="link">{{ live.title }}</router-link>
      </div>
      <div class="who" v-else>
        {{ live.title }}
      </div>
      <small class="who">
        <router-link :to="{name: 'artist-about', params: {artistId: live.artist.id }}">{{ live.artist.name }}</router-link>
      </small>
    </div>
    <b-button class="btn-rainbow" @click="addToWatchlist" size="sm" v-if="isLoggedIn && withWatchlistButton && !amWatching">
      <font-awesome-icon icon="plus"/> <span class="label">&nbsp; watchlist</span>
    </b-button>
    <b-button class="remove-from-watchlist" @click="removeFromWatchlist" size="sm" v-if="isLoggedIn && withWatchlistButton && amWatching">
      <font-awesome-icon icon="times" /> <span class="label">&nbsp; remove from watchlist</span>
    </b-button>
  </div>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';
  @import '~bootstrap/scss/mixins/_breakpoints.scss';

  .event-card {
    background: $dark;
    position: relative;
    cursor: pointer;
    width: 31%;

    border-radius: 4px;
    box-shadow: 5px 5px 10px 0 rgba(0, 0, 0, 0.57);

    padding-bottom: 1.5em;
    margin: 10px;
    margin-bottom: 3em;

    color: $white;
    font-size: 1em;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    @include media-breakpoint-down(lg) {
      width: 47%;
    }
    @include media-breakpoint-down(md) {
      width: 45%;
    }
    @include media-breakpoint-down(sm) {
      font-size: 1em;
    }

    .thumb {
      position: relative;
      width: 100%;
      height: 140px;
      background-size: cover;
      background-position: top center;
      background-repeat: no-repeat;

      .live {
        position: absolute;
        top: 10px;
        right: 10px;
        font-size: 0.8em;
        padding: 3px 10px 1px 10px;
        border-radius: 2px;
        background-color: $tomato;
        box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.64);
      }
    }

    .watchlist {
      position: absolute;
      top: 8px;
      left: 0;
      padding: 0.2em .6em 0.2em .7em;
      border-radius: 0 4px 4px 0;
      background-color: transparentize(#777, .2);
      display: flex;
      align-items: center;
      z-index: 1;

      .views {
        font-size: 0.9em;
        font-family: 'AvenirHeavy';
        line-height: 1.5;
      }

      i.sl-icon-eye {
        margin-right: 0.5em;
        /* margin-top: -2px; */
      }
    }

    .info {
      padding-left: 10px;
      padding-right: 10px;
    }

    .title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 0.5em;

      .price {
        font-size: 0.8em;
        flex-basis: 3em;
        width: 3em;
        height: 3em;
        color: $white;
        background: $darkish-pink;
        border-radius: 100%;
        line-height: 3em;
        font-weight: bold;
        text-align: center;

        &.free {
          padding: 0.25em 1em 0.18em 1em;
          line-height: inherit;
          height: auto;
          width: auto;
          border-radius: 4px;
        }
      }

      .when {
        padding: 3px 10px 3px 10px;
        font-size: 0.8em;
        font-weight: 900;
        text-align: right;
        color: $dark-five;
        border-radius: 4px;
        background-color: $pale-gold;
      }
    }

    .who {
      font-weight: bold;

      a {
        color: $white;
      }
    }
    @include media-breakpoint-down(xs) {
      width: 45%;
      margin-bottom: 3em;
      .thumb {
        width: 100%;
        height: 180px;
      }
    }
    @media screen and (max-width: 435px) {
      width: 100%;
    }
  }

  .btn-rainbow {
    padding: 0.25em 1em;
    position: absolute;
    right: 10px;
    bottom: -1em;
  }

  .remove-from-watchlist {
    padding: 0.25em 1em;
    position: absolute;
    background: $tomato;
    border-color: $tomato;
    right: 10px;
    bottom: -1em;
  }
  @include media-breakpoint-down(xs) {
    .label {
      display: none;
    }
  }

</style>

<script>
import find from 'lodash/find'
import { mapGetters } from 'vuex'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

import moment from '@/utils/moment'

export default {
  name: 'EventCard',
  components: {
    FontAwesomeIcon
  },
  props: {
    live: Object,
    to: Object,
    canRemove: Boolean,
    withWatchlistButton: Boolean
  },
  computed: {
    when () {
      return moment(this.live.start).format('MMM Do | h:mm a')
    },
    ticketCount () {
      return this.live.ticket_count || 0
    },
    cardStyle () {
      return {
        'background-image': 'linear-gradient(to bottom, rgba(0,0,0,0), #1c1c30), ' +
                    'url(\'' + this.live.promo_image + '\')'
      }
    },
    amWatching () {
      if (!this.live) return false
      return find(this.currentUser.watchlist, { id: this.live.id })
    },
    formatPrice () {
      if (!this.live) return ''
      if (this.hasBooked) return 'booked'
      if (this.live.price === 0) return 'free'
      if (this.live.price === null) return '$'

      let txt = this.live.price.toFixed(2)
      const m = txt.match(/(.+)\.00$/)
      if (m) {
        txt = m[1]
      }
      return '$' + txt
    },
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters('profile', ['currentUser'])
  },
  methods: {
    gotoLink () {
      let to = this.to ? this.to : {
        name: 'artist-live-stream-detail',
        params: {
          artistId: this.live.artist.id,
          liveId: this.live.id
        }
      }
      this.$router.push(to)
    },
    async addToWatchlist (ev) {
      ev.stopPropagation()
      ev.preventDefault()

      try {
        await this.$store.dispatch('live/addToWatchlist', {id: this.live.id})
        this.live.ticket_count++
        this.$store.dispatch('flash/showMessage', {message: 'Live stream added to watchlist'})
      } catch (e) {
        this.$store.dispatch('flash/showMessage', {message: 'This live event has passed', type: 'error'})
      }
    },
    async removeFromWatchlist (ev) {
      ev.stopPropagation()
      ev.preventDefault()

      await this.$store.dispatch('live/removeFromWatchlist', {id: this.live.id})
      this.$store.dispatch('flash/showMessage', {message: 'Live stream removed from watchlist'})
      this.$emit('remove')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/EventCard.vue